// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict'

//import Vue from "vue";
import api from '@/api/systemsettings.js'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    getSetting: (state) => (key) => {
      return state.list.find(function(item) {
        return item.key === key
      })
    }
  },
  mutations: {
    setSetting: (state, payload) => {
      const idx = state.list.findIndex(item => item.key === payload.key)
      if (idx > -1) {
        Vue.set(state.list, idx, payload)
      } else {
        state.list.unshift(payload)
      }
    }
  },
  actions: {
    async updateReportSections(_, keypairs) {
      const payload = keypairs.map((x) => { return {Label: x.Label, Active: x.Active}})
      let data = await api.updateReportSection(payload)
      console.log(data)
      if (data && data.Success === true) {
        return
      }
      throw new Error("Failed to update report section")
    },
    async fetchReportSections({ commit }) {
      let data = await api.fetchReportSection()
      if (data) {
        data.forEach((v) => {
          console.log("fetch report", v)
          commit('setSetting', {key: v.Label, value: v})
        })
      }
    },
    async updateSectionContent(_, keypairs) {
      const payload = keypairs.map((x) => { return {Label: x.Label, Content: x.Content, Active: x.Active}})
      const data = await api.updateSectionContent(payload)
      if (data && data.Success === true) {
        return
      }
      throw new Error("Failed to update section")
    },
    async fetchSectionContent({ commit }) {
      let data = await api.fetchSectionContent()
      if (data) {
        data.forEach((v) => {
          commit('setSetting', {key: v.Label, value: v})
        })
      }
    },
    async updateSmsMessage(_, keypairs) {
      const payload = keypairs.map((x) => { return { Label: x.Label, Content: x.Content, Active: x.Active}})
      const data = await api.updateSmsMessage(payload)
      if (data && data.Success === true) {
        return
      }
      throw new Error("Failed to update SMS message")
    },
    async fetchSmsMessage({ commit }) {
      let data = await api.fetchSmsMessage()
      if (data) {
        data.forEach((v) => {
          commit('setSetting', {key: v.Label, value: v})
        })
      }
    }
  }
}
